import Vue from 'vue'
import { formatIsoDateTimeAsTime } from '@/util/date-time-helper'
import { formatNumAsString } from '@/util/num-format'
import { getCurrency } from '@/util/money'

const setSpaces = (num) => {
  let val = ''
  val = num.toString().split('').reverse()
  for (let i = 1; i < val.length; i++) {
    if (i % 3 === 0) {
      val[i] = `${val[i]} `
    }
  }
  val = val.reverse().join('')
  return val
}

const currency = Vue.filter('currency', value => {
  value = value ?? '-'
  if (typeof value !== 'undefined') {
    const hasFloatPart = value.toString().includes('.')
    if (!hasFloatPart) {
      value = setSpaces(value)
    } else {
      let integerPart = value.toString().split('.')[0]
      let floatPart = value.toString().split('.')[1]
      integerPart = setSpaces(integerPart)
      floatPart = setSpaces(floatPart)
      value = `${integerPart}.${floatPart}`
    }
  }
  return value
})

const amountInRub = Vue.filter('amountInRub', value => {
  value = value ?? '-'
  if (typeof value !== 'undefined') {
    const hasFloatPart = value.toString().includes('.')
    if (!hasFloatPart) {
      value = setSpaces(value)
    } else {
      let integerPart = value.toString().split('.')[0]
      let floatPart = value.toString().split('.')[1]
      integerPart = setSpaces(integerPart)
      floatPart = setSpaces(floatPart)
      value = `${integerPart}.${floatPart}`
    }
  }
  if (parseFloat(value) !== 0) {
    value += ' ₽'
  }
  return value
})

const amountWithCurrency = Vue.filter('amountWithCurrency', value => {
  const currency = getCurrency()
  const formattedAmount = formatNumAsString(value)
  return `${formattedAmount} ${currency}`
})

const amountWithCurrency0 = Vue.filter('amountWithCurrency0', value => {
  if (!!value === false) {
    return 0
  }
  const currency = getCurrency()
  const formattedAmount = formatNumAsString(value)
  return `${formattedAmount} ${currency}`
})

const amountStringWithCurrency = Vue.filter('amountStringWithCurrency', value => {
  if (value) {
    const currency = getCurrency()
    return `${value} ${currency}`
  }
  return value
})

const asFormattedTime = Vue.filter('asFormattedTime', value => {
  return formatIsoDateTimeAsTime(value)
})

export default {
  currency,
  amountInRub,
  asFormattedTime,
  amountWithCurrency,
  amountWithCurrency0,
  amountStringWithCurrency,
}
